import type { ComponentProps } from 'react';
import type React from 'react';

import { Image, Spinner } from '@change/ds-core-ui';

import { useProcessedImage } from '#src/app/shared/hooks/image';

type PhotoProps = {
	aspectRatio: '1/1' | '16/9';
	processing: boolean;
	alt: string;
	src: string;
};

const DS_ASPECT_RATIO = { '1/1': '1:1', '16/9': '16:9' } as const;

export const Photo: React.FC<PhotoProps & Omit<ComponentProps<typeof Image>, 'aspectRatio'>> = ({
	aspectRatio,
	processing,
	src,
	alt,
	...rest
}) => {
	const image = useProcessedImage({ url: src, processing });

	if (image.processing) {
		return (
			<div
				className="flex h-full items-center justify-center overflow-hidden"
				style={{ aspectRatio }}
				aria-hidden="true"
				// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
				{...(rest as any)}
			>
				<Spinner className="size-4" />
			</div>
		);
	}

	return (
		<Image
			src={image.url}
			alt={alt}
			aspectRatio={DS_ASPECT_RATIO[aspectRatio]}
			className="h-full object-cover align-top"
			loading="lazy"
			{...rest}
		/>
	);
};
